<template>
  <AddEditFolder></AddEditFolder>
</template>

<script>
import AddEditFolder from "./subfolder-add.vue";
export default {
  components: {
    AddEditFolder,
  },
};
</script>
